var modProductDetail = function(){
    var scope = ".js-mod-product-detail";
    ui.ready(
        scope,
        function($mod){
            var $repeatItems = $mod.find(scope+"__repeat-item");
            var $daysItems = $mod.find(scope+"__repeat-days");

            function updateTargetPrice(){
                gvf.delay(
                    500,
                    function(){
                        shopCart.getTargetPrice(
                            $mod.data("product-id"),
                            $mod.find(".js-cart-add").getQuantity(),
                            function(data){
                                $mod.find(scope+"__price").html(data.html);
                                $mod.addClass("has-modified-selection");
                            },
                            null,
                            $repeatItems.filter(".is-selected").data("id"),
                            $daysItems.filter(".is-selected").data("n")
                        );
                    }
                );
            }

            $mod.find(scope+"__buy,"+scope+"__buy-confirm").click(
                function(ev){
                    ev.preventDefault();
                    var quantity = $mod.find(".js-cart-add").getQuantity();
                    if($(this).is(scope+"__buy") && quantity==0){
                        quantity = 1;
                    }
                    shopCart.setProductQuantity(
                        $mod.data("product-id"),
                        quantity,
                        function(data){
                            $mod.data("cart-quantity",data.quantity);
                            $mod.toggleClass("is-in-cart",data.quantity>0);
                            $mod.trigger("web:cartQuantityUpdate",data);
                            if($repeatItems.length>0){
                                $mod.find(scope+"__hide-when-repeat-added").slideUp();
                            }
                        },
                        null,
                        $repeatItems.filter(".is-selected").data("id"),
                        $daysItems.filter(".is-selected").data("n")
                    );
                }
            );

            $mod.find(scope+"__repeat-item").click(
                function(ev){
                    ev.preventDefault();
                    if(!$(this).hasClass("is-selected")){
                        $(this).addClass("is-selected").siblings().removeClass("is-selected");
                        updateTargetPrice();
                    }
                }
            );

            $mod.find(scope+"__repeat-days").click(
                function(ev){
                    ev.preventDefault();
                    if(!$(this).hasClass("is-selected")){
                        $(this).addClass("is-selected").siblings().removeClass("is-selected");
                        updateTargetPrice();
                    }
                }
            );

            $mod.on(
                "web:cartAddQuantityUpdate",
                function(ev,data){
                    updateTargetPrice();
                }
            );

            $mod.find(scope+"__buy").toggle($mod.data("cart-quantity")==0);
            $mod.find(scope+"__buy-confirm").toggle($mod.data("cart-quantity")>0);
            $mod.toggleClass("is-in-cart",$mod.data("cart-quantity")>0);
            //select default option (if present)
            if($mod.data("cart-quantity")==0){
                if($mod.data("enable-days").length==1 || $mod.data("enable-days").length==2){
                    $mod.find(scope+"__repeat-days[data-n=1]").click();
                }else{
                    $mod.find(scope+"__repeat-days[data-n=3]").click();
                }
            }
            if($repeatItems.filter(".is-selected").data("id")){
                updateTargetPrice();
            }
        }
    );
    ui.readyBody(
        function($body){
            $body.on(
                "web:cartQuantityUpdate",
                function(ev,data){
                    gvf.delay(
                        500,
                        function(){
                            var $items = $(scope);
                            if(data.product_id){
                                $items = $items.filter("[data-product-id="+data.product_id+"]");
                            }
                            $items.each(
                                function(){
                                    $(this).data("cart-quantity",data.quantity?data.quantity:0);
                                    $(this).toggleClass("is-in-cart",data.quantity>0);
                                    $(this).find(scope+"__buy").toggle(data.quantity==0);
                                    $(this).find(scope+"__buy-confirm").toggle(data.quantity>0);
                                    $(this).removeClass("has-modified-selection");
                                }
                            );
                        }
                    );
                }
            );
        }
    );
}();